const AuthRoutes = {
  getAllJobs: "/admin/getAll",
  getAllUsers: "/auth/allusers",
  login: "/auth/login",
  approveAd: "/admin/approveAd",
  approveFeature: "/ad/updateFeatureStatus",
  getWithdrawRequests: "/auth/getWithdrawRequest",
  updateWithdrawRequest: "/auth/updateWithdrawRequest",
  getPlatformFee: "/fee/getFee",
  updatePlatformFee: "/fee/updateFee",
  getTransactionHistory: "/auth/getWalletHistory"
};

export default AuthRoutes;